import { atom } from 'jotai';
import { S2MosaicQuarterly_Item } from '~/common/typescript/apis/RemoteImageAlertAPIs';

export const s2MosaicQuarterlyItemsLEFTAtom = atom<S2MosaicQuarterly_Item[]>([]);
export const s2MosaicQuarterlyItemsRIGHTAtom = atom<S2MosaicQuarterly_Item[]>([]);

export const s2MosaicQuarterlyLoadingAtom = atom<{
  isLoading: boolean;
  text: string;
}>({
  isLoading: false,
  text: '',
});

export const s2MosaicQuarterlyYearAtom = atom<number | undefined>(undefined);
export const s2MosaicQuarterlyQuarterAtom = atom<number | undefined>(undefined);
